import { createAction } from 'redux-actions';

import getTypes from './types';

const getActions = storeName => {
    const types = getTypes(storeName);
    const initialize = createAction(types.INITIALIZE);
    const setInitialized = createAction(types.AFTER_INITIALIZE);
    const setInitialData = createAction(types.SET_INITIAL_DATA);

    const _setDataFieldValue = createAction(types.SET_DATA_FIELD_VALUE);
    const setDataFieldValue = (name, value, skipValidation, prefill, save) =>
        value === undefined
            ? _setDataFieldValue({ name, skipValidation, prefill })
            : _setDataFieldValue({
                  name,
                  value,
                  skipValidation,
                  prefill,
                  save,
              });

    const initDataFieldValue = (name, value) =>
        _setDataFieldValue({
            name,
            value,
            skipValidation: true,
            prefill: true,
        });

    const setDataFieldValues = createAction(types.SET_DATA_FIELD_VALUES);
    const setScrollToField = createAction(types.SET_SCROLL_TO_FIELD);
    const _setDataFieldError = createAction(types.SET_DATA_FIELD_ERROR);
    const setDataFieldError = (name, error) => _setDataFieldError({ name, error });
    const _setDataFieldTypeError = createAction(types.SET_DATA_FIELD_TYPE_ERROR);
    const setDataFieldTypeError = (name, typeError) => _setDataFieldTypeError({ name, typeError });
    const _setDataFieldType = createAction(types.SET_DATA_FIELD_TYPE);
    const setDataFieldType = (name, type) => _setDataFieldType({ name, type });
    const _addDataFieldLink = createAction(types.ADD_DATA_FIELD_LINK);
    const addDataFieldLink = (name, link) => _addDataFieldLink({ name, link });

    const setStep = createAction(types.SET_STEP);
    const setStepDataChecker = createAction(types.SET_STEP_DATA_CHECKER);
    const setLoading = createAction(types.SET_LOADING);
    const setStepValidationLoading = createAction(types.SET_STEP_VALIDATION_LOADING);
    const setStepBack = createAction(types.SET_STEP_BACK);
    const afterStepValidation = createAction(types.AFTER_STEP_VALIDATION);
    const setErrorsText = createAction(types.SET_ERRORS_TEXT);
    const focusField = createAction(types.FOCUS_FIELD);
    const blurField = createAction(types.BLUR_FIELD);
    const touchField = createAction(types.TOUCH_FIELD);
    const setGlobalMessage = createAction(types.SET_GLOBAL_MESSAGE);
    const setGlobalSuccess = text =>
        setGlobalMessage({ success: true, error: false, warning: false, text });
    const setGlobalError = (text, type) =>
        setGlobalMessage({
            success: false,
            error: true,
            warning: false,
            text,
            type,
        });
    const setGlobalWarning = text =>
        setGlobalMessage({ success: false, error: false, warning: true, text });
    const resetGlobalMessage = () => setGlobalMessage();
    const setIsConstraintValid = createAction(types.SET_IS_CONSTRAINT_VALID);
    const resetData = createAction(types.RESET_DATA);
    const resetFormData = createAction(types.RESET_FORM_DATA);
    const setSubmitUrl = createAction(types.SET_SUBMIT_URL);
    const setSubmitMethod = createAction(types.SET_SUBMIT_METHOD);
    const setSuccessRedirectLink = createAction(types.SET_SUCCESS_REDIRECT_LINK);
    const setValidationFailed = createAction(types.SET_VALIDATION_FAILED);

    const dataFieldValidationDone = createAction(types.DATA_FIELD_VALIDATION_DONE);

    const addFieldItem = createAction(types.ADD_FIELD_ITEM);
    const _removeFieldItem = createAction(types.REMOVE_FIELD_ITEM);
    const removeFieldItem = (name, index) => _removeFieldItem({ name, index });

    const showAddressSuggestionsList = createAction(types.SHOW_ADDRESS_SUGGESTIONS_LIST);
    const hideAddressSuggestionsList = createAction(types.HIDE_ADDRESS_SUGGESTIONS_LIST);
    const selectAddressSuggestion = createAction(types.SELECT_ADDRESS_SUGGESTION);

    const _setAddressValidation = createAction(types.SET_ADDRESS_VALIDATION);

    const _setNestedAddressValidation = createAction(types.SET_NESTED_ADDRESS_VALIDATION);

    const changeAddressField = createAction(types.CHANGE_ADDRESS_FIELD);

    const setAddressValidation = (isValid, isNested) =>
        isNested ? _setNestedAddressValidation(isValid) : _setAddressValidation(isValid);

    const formSubmitted = createAction(types.FORM_SUBMITTED);

    const updateConstraints = createAction(types.UPDATE_CONSTRAINTS);

    const setDataFieldReadonlyStatus = createAction(types.SET_DATA_FIELD_READONLY_STATUS);

    const setDataFieldDisabledStatus = createAction(types.SET_DATA_FIELD_DISABLED_STATUS);
    const disableStep1Button = createAction(types.DISABLE_STEP1_BUTTON);
    const setLoyaltyFlag = createAction(types.SET_LOYALTY_FLAG);

    return {
        initialize,
        setInitialized,
        setInitialData,
        initDataFieldValue,
        setDataFieldValue,
        setDataFieldValues,
        addDataFieldLink,
        setDataFieldError,
        setDataFieldTypeError,
        setDataFieldType,
        setStep,
        setStepDataChecker,
        setLoading,
        setStepValidationLoading,
        setStepBack,
        dataFieldValidationDone,
        addFieldItem,
        removeFieldItem,
        afterStepValidation,
        setIsConstraintValid,
        resetGlobalMessage,
        setGlobalSuccess,
        setGlobalError,
        setGlobalWarning,
        setErrorsText,
        focusField,
        blurField,
        touchField,
        resetData,
        resetFormData,
        setSubmitUrl,
        setSubmitMethod,
        setValidationFailed,
        setScrollToField,
        showAddressSuggestionsList,
        hideAddressSuggestionsList,
        selectAddressSuggestion,
        setAddressValidation,
        changeAddressField,
        formSubmitted,
        updateConstraints,
        setDataFieldReadonlyStatus,
        setDataFieldDisabledStatus,
        setSuccessRedirectLink,
        disableStep1Button,
        setLoyaltyFlag,
    };
};

export default getActions;
